import React, { useState } from 'react';
import PropTypes from 'prop-types';
import NewsShowContext from '../context/news_show_context';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import ShareEmailModal from './components/share_email_modal/share_email_modal';
import ShareLinkModal from './components/share_link_modal/share_link_modal';
import './button_article_share.scss';

const ButtonArticleShare = ({ articleId, setAlertData }) => {
  const [isShareEmailModalOpen, setIsShareEmailModalOpen] = useState(false);
  const [isShareLinkModalOpen, setIsShareLinkModalOpen] = useState(false);

  return (
    <div data-testid='share-article' className='react-c-share-article'>
      <NewsShowContext.Provider
        value={{
          articleId,
        }}
      >
        <DropdownButton
          className='react-c-share-article-btn'
          variant='outline-secondary'
          id={`share-article-${articleId}`}
          title=''
        >
          <Dropdown.Item as='button' onClick={() => setIsShareEmailModalOpen(true)}>
            Share by email
          </Dropdown.Item>
          <Dropdown.Item as='button' onClick={() => setIsShareLinkModalOpen(true)}>
            Get shareable link
          </Dropdown.Item>
        </DropdownButton>
        <ShareEmailModal
          setAlertData={setAlertData}
          isShareEmailModalOpen={isShareEmailModalOpen}
          closeShareEmailModal={() => setIsShareEmailModalOpen(false)}
        />
        <ShareLinkModal
          isShareLinkModalOpen={isShareLinkModalOpen}
          closeShareLinkModal={() => setIsShareLinkModalOpen(false)}
        />
      </NewsShowContext.Provider>
    </div>
  );
};

ButtonArticleShare.propTypes = {
  articleId: PropTypes.number.isRequired,
  setAlertData: PropTypes.func.isRequired,
};

export default ButtonArticleShare;
